module.exports = __webpack_public_path__ + "static/img/battery.47c5c48b.svg";